import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ToolExecution } from '../../types/chat.types';
import './ToolExecutionBadge.css';

interface ToolExecutionBadgeProps {
  execution: ToolExecution;
}

/**
 * Tool execution badge component
 * Displays tool name with running/completed status
 */
function ToolExecutionBadge({ execution }: ToolExecutionBadgeProps) {
  const { t } = useTranslation();

  return (
    <div className={`tool-badge ${execution.status}`}>
      <span className="tool-icon">🔧</span>
      <span className="tool-name">
        {t('chat.tool_execution', { toolName: execution.tool })}
      </span>
      {execution.status === 'running' && (
        <span className="tool-spinner">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="spinner"
          >
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
          </svg>
        </span>
      )}
      {execution.status === 'completed' && (
        <span className="tool-check">✓</span>
      )}
    </div>
  );
}

export default ToolExecutionBadge;
